import { AnimatePresence, motion } from 'framer-motion'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './components/organisms/Sidebar'
import Header from './components/organisms/Header'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const pageVariants = {
	initial: {
		opacity: 0,
	},
	in: {
		opacity: 1,
	},
	out: {
		opacity: 0,
	},
}

function App() {
	const location = useLocation()

	return (
		<>
			<AnimatePresence>
				<Header path={location.pathname} />
				<Sidebar key='sidebar' />
				<motion.div
					initial='initial'
					animate='in'
					exit='out'
					variants={pageVariants}
					key={location.pathname}>
					<Outlet key='page' />
				</motion.div>
			</AnimatePresence>
		</>
	)
}

export default App
